const asyncActionType = type => ({
  pending: `${type}_PENDING`,
  success: `${type}_SUCCESS`,
  error: `${type}_ERROR`
});
export const FETCH_OPERATIONSDASHBOARD = asyncActionType('aerosimple/operations_dashnoard/FETCH_OPERATIONSDASHBOARD');
export const CLEAR_OPERATIONSDASHBOARD = 'aerosimple/workorders/CLEAR';
